import { __assign, __extends, __rest } from "tslib";
import classNames from 'classnames';
import React, { Component, } from 'react';
import styles from './Thumbnail.scss';
var ThumbnailShapeMode;
(function (ThumbnailShapeMode) {
    ThumbnailShapeMode["RECTANGLE"] = "RECTANGLE";
    ThumbnailShapeMode["SQUARE"] = "SQUARE";
})(ThumbnailShapeMode || (ThumbnailShapeMode = {}));
var ThumbnailContainer = function (props) { return (React.createElement("div", __assign({}, props, { className: classNames(styles.thumbnail, props.className), "data-hook": "thumbnail" }), props.children)); };
var Thumbnail = /** @class */ (function (_super) {
    __extends(Thumbnail, _super);
    function Thumbnail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            if (!event.isDefaultPrevented() && _this.props.onClick) {
                _this.props.onClick(event);
            }
        };
        _this.handleChange = function (event) {
            if (!event.isDefaultPrevented() && _this.props.onChange) {
                _this.props.onChange(event.target.checked);
            }
        };
        return _this;
    }
    Thumbnail.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, isDisabled = _b.isDisabled, isSelectable = _b.isSelectable, isMulti = _b.isMulti, selected = _b.selected, shapeMode = _b.shapeMode, className = _b.className, onChange = _b.onChange, label = _b.label, tooltip = _b.tooltip, props = __rest(_b, ["children", "isDisabled", "isSelectable", "isMulti", "selected", "shapeMode", "className", "onChange", "label", "tooltip"]);
        return (React.createElement(ThumbnailContainer, __assign({ className: classNames(isMulti ? styles.multi : styles.single, (_a = {},
                _a[styles.selected] = selected,
                _a[styles.thumbnailRectangle] = shapeMode === ThumbnailShapeMode.RECTANGLE,
                _a), className) }, props),
            React.createElement("div", { className: styles.hoverOverlay }),
            React.createElement("label", { className: styles.overlay, tabIndex: isDisabled || isSelectable ? undefined : 0, onClick: isDisabled ? undefined : this.handleClick, "data-hook": "thumbnail-label", "aria-label": label, title: tooltip }, isSelectable ? (React.createElement("span", { className: styles.checkBox },
                React.createElement("input", { type: "checkbox", checked: selected, disabled: isDisabled, onChange: this.handleChange }),
                isMulti ? React.createElement("span", { className: styles.checkMark }) : null)) : null),
            children));
    };
    Thumbnail.defaultProps = {
        isSelectable: false,
        isMulti: false,
        selected: false,
        shapeMode: ThumbnailShapeMode.SQUARE,
    };
    return Thumbnail;
}(Component));
export default Thumbnail;
export { ThumbnailContainer, ThumbnailShapeMode };
//# sourceMappingURL=Thumbnail.js.map